import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const BillUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  vendorDocumentRef, onVendorDocumentRefChange, vendorDocumentRefError, setVendorDocumentRefError,
  itemSpec, onItemSpecChange, itemSpecError, setItemSpecError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update vendor bill'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='vdr'
      label='Vendor document ref' maxLength={100}
      value={vendorDocumentRef} onChange={onVendorDocumentRefChange}
      error={vendorDocumentRefError} setError={setVendorDocumentRefError}
    />
    <InputTextAreaSF type='text' name='itemSpecification'
      label='Item specification' maxLength={500}
      value={itemSpec} onChange={onItemSpecChange}
      error={itemSpecError} setError={setItemSpecError}
      help='200 characters max'
    />
  </ModalFormUI>

export default BillUpdateModalUI
